import { TReduxActions } from '../../actions';
import { EHideOfferActionTypes } from '../../actions/hiddenObjects/types';
import { IHiddenObjectsState } from '../../types/hiddenObjects';

const defaultState: IHiddenObjectsState = { ids: [] };

export function hiddenObjectsReducer(state = defaultState, action: TReduxActions): IHiddenObjectsState {
  switch (action.type) {
    case EHideOfferActionTypes.Success:
      if (state.ids.includes(action.payload.offerId)) {
        return state;
      }

      return { ids: [...state.ids, action.payload.offerId] };
    default:
      return state;
  }
}
